import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

// Cash-register "ca-ching": a quick drawer clunk then two bright bell tones.
export function playCaChing() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const t = ctx.currentTime;
    const tone = (freq, at, len, type = "triangle", vol = 0.35) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = type; o.frequency.setValueAtTime(freq, t + at);
      g.gain.setValueAtTime(0.0001, t + at); g.gain.exponentialRampToValueAtTime(vol, t + at + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + at + len);
      o.connect(g).connect(ctx.destination); o.start(t + at); o.stop(t + at + len + 0.05);
    };
    tone(140, 0, 0.12, "square", 0.2);
    tone(2093, 0.12, 0.5); tone(2637, 0.12, 0.5, "sine", 0.2);
    tone(2637, 0.3, 0.9); tone(3136, 0.3, 0.9, "sine", 0.2);
    return ctx.state !== "suspended";
  } catch { return false; }
}

// Opens from a sale alert (/?sold=<id>): Pac-Man eats the $ then the logo, with a ca-ching.
export default function SaleCheer() {
  const [params, setParams] = useSearchParams();
  const id = params.get("sold");
  const [sale, setSale] = useState(null);
  const [run, setRun] = useState(false);
  useEffect(() => {
    if (!id) return;
    api.get(`/drafts/${id}`).then(({ data }) => setSale(data)).catch(() => setSale({}));
    setTimeout(() => setRun(true), 50);
    playCaChing();
  }, [id]);
  if (!id || !sale) return null;
  const close = () => { params.delete("sold"); setParams(params, { replace: true }); setSale(null); setRun(false); };
  const price = sale.ebay?.sold_price;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/80 p-6" onClick={close} data-testid="sale-cheer">
      <div className="w-full max-w-sm rounded-2xl bg-slate-900 p-6 text-center text-white" onClick={(e) => { e.stopPropagation(); playCaChing(); }}>
        <p className="font-mono text-xs uppercase tracking-widest text-yellow-300">Ca-ching!</p>
        <p className="mt-1 text-3xl font-bold" data-testid="sale-cheer-title">Sold!</p>
        <p className="mt-1 truncate text-sm text-slate-300" data-testid="sale-cheer-item">{sale.title || "Your item"}{price ? ` · $${Number(price).toFixed(2)}` : ""}</p>
        <div className={`lp-track mt-5 ring-1 ring-slate-700 ${run ? "lp-complete" : ""}`} style={{ "--pm": "22px" }} aria-hidden="true">
          {[20, 40, 60, 80].map((x) => <span key={x} className={`lp-dollar ${run ? "lp-eaten" : ""}`} style={{ left: `${x}%`, transitionDelay: `${x / 100}s` }}>$</span>)}
          <span className="lp-logo">SL</span>
          <span className="lp-man pm-man" style={{ left: run ? "calc(100% - 22px)" : "0", transitionDuration: "1.4s" }}><span className="pm-jaw pm-top" /><span className="pm-jaw pm-bottom" /></span>
        </div>
        <p className="mt-4 text-[11px] text-slate-400">Tap the card for another ca-ching</p>
        <button type="button" onClick={close} className="mt-3 rounded-full bg-yellow-400 px-5 py-2 text-sm font-bold text-slate-900" data-testid="sale-cheer-close">Nice!</button>
      </div>
    </div>
  );
}
